"use client"

import { Slider } from "../../../components/ui/slider"
import { Label } from "../../../components/ui/label"
import { Input } from "../../../components/ui/input"
import type { Vec3 } from "./take-types"

interface SliderFieldProps {
  label: string
  value: number
  min: number
  max: number
  step: number
  unit?: string
  onChange: (v: number) => void
}

export function SliderField({ label, value, min, max, step, unit, onChange }: SliderFieldProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-xs text-muted-foreground">{label}</Label>
        <span className="font-mono text-xs tabular-nums text-foreground">
          {value.toFixed(step < 1 ? 2 : 0)}
          {unit ? ` ${unit}` : ""}
        </span>
      </div>
      <Slider
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={(v) => onChange(v[0])}
      />
    </div>
  )
}

interface Vec3FieldProps {
  label: string
  value: Vec3
  step?: number
  min?: number
  max?: number
  onChange: (v: Vec3) => void
}

export function Vec3Field({ label, value, step = 0.05, min = -5, max = 5, onChange }: Vec3FieldProps) {
  const axes: (keyof Vec3)[] = ["x", "y", "z"]
  return (
    <div className="space-y-2">
      <Label className="text-xs font-medium text-foreground">{label}</Label>
      <div className="grid grid-cols-3 gap-2">
        {axes.map((axis) => (
          <div key={axis} className="space-y-1">
            <Label className="text-[10px] uppercase text-muted-foreground">{axis}</Label>
            <Input
              type="number"
              step={step}
              min={min}
              max={max}
              value={Number.isFinite(value[axis]) ? value[axis] : 0}
              onChange={(e) => onChange({ ...value, [axis]: Number.parseFloat(e.target.value) || 0 })}
              className="h-8 font-mono text-xs"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
